import React from "react";
import { findDOMNode } from "react-dom";
import classNames from "classnames";
import isEmpty from "lodash/isEmpty";
import Tree from "./react-virtualized-tree/src";
import baron from "../wea-new-scroll/baron/src/core";
import { traverTree } from "./util";

let count = 0;
const Expandable = ({
  node,
  children,
  onExpand,
  onSelect,
  onDoubleClick,
  checkable,
  disableCheckbox,
  onCheck,
  hasRadio,
  disableRadio,
  onRadioCheck,
  expandedKeys,
  itemMainKey,
  isExpandOnDoubleClick
}) => {
  const { childs, isLeaf, checked, halfcheck, isParent } = node;
  const hasChildren =
    ("isLeaf" in node && !isLeaf) || (childs && childs.length) || isParent;
  const stopPropagation = e => {
    e.stopPropagation && e.stopPropagation();
    e.preventDefault && e.preventDefault();
    e.nativeEvent && e.nativeEvent.preventDefault();
  };

  const renderExpand = () => {
    return (
      <i
        onClick={e => {
          hasChildren && onExpand(node, e);
          stopPropagation(e);
        }}
        className={classNames({
          "ant-tree-icon": true,
          "ant-tree-switcher": true,
          "icon-coms-organization-down":
            hasChildren && expandedKeys.some(k => k === node[itemMainKey]),
          "icon-coms-organization-right":
            hasChildren && !expandedKeys.some(k => k === node[itemMainKey])
        })}
      />
    );
  };
  const renderCheck = () => {
    let checkbtn;
    if (checkable) {
      checkbtn = (
        <span
          onClick={e => {
            !disableCheckbox && onCheck(node, e);
            stopPropagation(e);
          }}
          className={classNames({
            "ant-tree-checkbox": true,
            "ant-tree-checkbox-checked": checked,
            "ant-tree-checkbox-indeterminate": halfcheck,
            "ant-tree-checkbox-disabled": disableCheckbox
          })}
        >
          <span className="ant-tree-checkbox-inner"></span>
        </span>
      );
      if (hasRadio) {
        checkbtn = (
          <span
            onClick={e => {
              !disableCheckbox && onRadioCheck(node, e);
              stopPropagation(e);
            }}
            className={classNames({
              "ant-tree-radio": true,
              "ant-tree-radio-checked": checked,
              "ant-tree-radio-disabled": disableRadio
            })}
          >
            <span className="ant-tree-radio-inner"></span>
          </span>
        );
      }
    }
    return checkbtn;
  };
  return [
    renderExpand(),
    renderCheck(),
    node.icon && (
      <i
        className={classNames({
          "ant-tree-icon": true,
          [node.icon]: true
        })}
      />
    ),
    <a
      className={classNames({
        "ant-tree-node-content-wrapper": true,
        "ant-tree-node-disabled": node.isCheck
      })}
      // style={{ height: '26px', lineHeight: '26px' }}
      onClick={e => {
        if (node.isCheck) return;
        count++;
        setTimeout(() => {
          if (isExpandOnDoubleClick || count === 1) {
            onSelect(node, e);
            hasChildren && onExpand(node, e);
            stopPropagation(e);
          }
          if (count === 2 && node.type !== "3") {
            // 双击
            typeof onDoubleClick === "function" && onDoubleClick(node, e);
          }
          count = 0;
        }, 300);
      }}
    >
      {children}
    </a>
  ].filter(Boolean);
};

export default class ScrollTree extends React.Component {
  baron = null;
  componentDidMount() {
    const root = findDOMNode(this.root);
    const scrollerParent = findDOMNode(this.scroller);
    const scroller = scrollerParent.querySelector(".scroller");
    const track = findDOMNode(this.track);
    const bar = findDOMNode(this.bar);
    this.baron = baron({
      $: window.jQuery,
      root,
      clipper: root,
      scroller: scroller,
      track: track,
      bar: bar,
      notParentClipper: true
    });
    this.updateData();
  }
  componentWillReceiveProps(nextProps) {
    let update = false;
    if (
      nextProps.expandedKeys != undefined &&
      this.props.expandedKeys != nextProps.expandedKeys
    ) {
      update = true;
    }
    if (
      nextProps.checkedKeys != undefined &&
      this.props.checkedKeys != nextProps.checkedKeys
    ) {
      update = true;
    }
    if (update) {
      this.updateData(nextProps);
    }
  }
  updateData = props => {
    const { datas, itemMainKey, expandedKeys, checkedKeys, isOrg } =
      props || this.props;
    traverTree(datas, node => {
      const key = node[itemMainKey];
      node.isopen = !isEmpty(expandedKeys) && expandedKeys.indexOf(key) !== -1;
      node.checked = !isEmpty(checkedKeys) && checkedKeys.indexOf(key) !== -1;
    });
    this.forceUpdate();
  };
  componentWillUnmount() {
    if (this.baron) {
      this.baron.dispose();
      this.baron = null;
    }
  }
  getCheckedKeys = (data, node, checked) => {
    let checkedKeys = [];
    let checkedNodes = [];
    const newSt = {
      event: "check",
      node,
      checkedKeys,
      checkedNodes,
      checked
    };
    return newSt;
  };
  onCheck = (node, e) => {
    const { datas, onCheck } = this.props;
    const checked = !(node.checked || false);
    const { checkedKeys, checkedDatas } = this.getCheckedKeys(
      datas,
      node,
      checked
    );
    // onCheck && onCheck(checkedKeys, checkedDatas, e);
  };
  onRadioCheck = (node, e) => {};
  isCheckboxDisable = item => {
    const { props } = this;
    if (props.isCheckboxDisable) {
      return props.isCheckboxDisable(item);
    }
    return !item.canClick || false;
  };
  isRadioDisable = item => {
    const { props } = this;
    if (props.isRadioDisable) {
      return props.isRadioDisable(item);
    }
    return !item.canClick || false;
  };
  // get
  getScrollerTrack = () => {
    return (
      <div ref={el => (this.track = el)} className="track">
        <div ref={el => (this.bar = el)} className="bar" />
      </div>
    );
  };
  renderExpandable = ({ style, node, ...rest }) => {
    const { props } = this;
    const {
      checkable,
      hasRadio,
      itemMainKey,
      selectedKeys,
      getTitle,
      onExpand,
      onSelect,
      onDoubleClick,
      isExpandOnDoubleClick,
      expandedKeys,
      isOrg
    } = props;
    const className = classNames({
      "wea-tree-wrap": true,
      "wea-tree-wrap-true": selectedKeys.some(k => k === node[itemMainKey])
    });
    this.treeMap[node.id] = node;
    style.height = node.type === "3" ? "34px" : "26px";
    style.lineHeight = node.type === "3" ? "34px" : "26px";
    return (
      <div className={className} style={style}>
        <Expandable
          node={node}
          isOrg={isOrg}
          {...rest}
          checkable={checkable}
          expandedKeys={expandedKeys}
          itemMainKey={itemMainKey}
          // checkboxChecked={this.isCheckboxChecked(node)}
          disableCheckbox={this.isCheckboxDisable(node)}
          hasRadio={hasRadio}
          disableRadio={this.isRadioDisable(node)}
          isExpandOnDoubleClick={isExpandOnDoubleClick}
          // radioChecked={this.isRadioChecked(node)}
          onCheck={this.onCheck}
          onRadioCheck={this.onRadioCheck}
          onExpand={onExpand}
          onSelect={onSelect}
          onDoubleClick={onDoubleClick}
        >
          {getTitle(node)}
        </Expandable>
      </div>
    );
  };
  render() {
    const { props } = this;
    const { datas, itemMainKey } = props;
    this.treeMap = {};
    return (
      <div
        ref={el => (this.root = el)}
        className="wea-tree-baron baron"
        style={{
          width: "100%",
          height: "100%",
          position: "relative",
          marginTop: "-5px"
        }}
      >
        <Tree
          nodes={datas}
          className="scroller ant-tree"
          ref={el => (this.scroller = el)}
          nodePaddingLeft={18}
          mainKey={itemMainKey}
        >
          {this.renderExpandable}
        </Tree>
        {this.getScrollerTrack()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./ecology9/wea-tree-test/ScrollTree.js